function lazyload() {
	$(window).on('load scroll resize', function() {
		$('.lazyload:visible').each(function() {
			if ( isVisible($(this)) ) {
				if ( $(this).data('srcset') ) {
					$(this).attr('srcset', $(this).data('srcset'));
					$(this).removeAttr('data-srcset');
				}

				if ( $(this).data('src') ) {
					$(this).attr('src', $(this).data('src'));
					$(this).removeAttr('data-src');
				}	

				if ( $(this).hasClass('d-none') ) {
					$(this).removeClass('d-none');
				}			
			}
		});	

		$('.lazyload-section').each(function() {
			if ( isVisible($(this)) ) {
				$(this).find('.lazyload-child-elem').removeClass('d-none');		
			}
		});		
	});
}
function isVisible(elem) {
	var scrollTop = $(window).scrollTop();
	var windowBottom = scrollTop + $(window).height();
	var offset = 100;
	var elementTop = elem.offset().top;

	if ( (windowBottom + offset) > elementTop ) {
		return true;
	} else {
		return false;
	}

	/*console.log('scrollTop: ' + scrollTop);
	console.log('elementTop: ' + elementTop);*/
}
